export const colors = {
  // fix 색상
  black: 'black',
  white: 'white',
  fixBackground: '#222222',
  fixTextColor: '#ffffff',
  fixSecondaryTextColor: '#898989',
  // fix 메인 컬러
  // primary: '#31859c',
  primary_blue: '#1568dd', // focus blue
  primary_pink: '#e4007f', // focus pink
  lightPrimary: '#F2AA4C',
  secondary: '#18424d',
  accent: '',
  important: '#f51717',
  // text 색상
  lightText: '#121212',
  // 배경 layer
  darkLayer1: "#121212",
  darkLayer2: "#3d3d3f",
  darkLayer3: "#545457",
  lightLayer1: "#fdfdfd",
  lightLayer2: "#F2F3F5",
  lightLayer3: "#d8d8d9",

  // 연결 상태 관련
  success: '#2faf5b',
  error: '#e33f3f',
  off: '#a9a9a9',
  // 환경센터 상태 관련
  veryBad: '#f34c4c',
  bad: '#f3744c',
  normal: '#fdd032',
  good: '#4bde4b',
  veryGood: '#47d3f2',
  // 메인 버튼
  btnDefaultText: '#fff',
  // darkPrimaryBtnBg: '#31859c',
  // lightPrimaryBtnBg: '#f2aa4c',
  darkPrimaryBtnBg: '#1568dd', // dark/light 동일 색상으로 변경
  lightPrimaryBtnBg: '#1568dd', // dark/light 동일 색상으로 변경
  // white버튼
  whiteBtnBg: '#fff',
  whiteBtnText: '#262626',
  darkWhiteBtnBorder: '1px solid #fff',
  lightWhiteBtnBorder: '1px solid #DEDEDE',
  // delete
  deleteBg: '#bf3257',
  // disabled
  disabledBg: '#E6E6E6',
  disabledText: '#666',
  // input
  darkInputReadOnlyBg: '#222222',
  darkInputReadOnlyText: '#dbdbdb',
  lightInputReadOnlyBg: '#b1b1b1',
  lightInputReadOnlyText: '#393939',
  // 아이콘 관련
  iconDefaultText: '#fff',
  iconLabel: '#7a7a7d',
  eventColor1: '#f79646',
  eventColor2: '#558ed5',
  eventColor3: '#ff0000',
  // table
  darkTableHeadBg: '#376092',
  darkTableHeadHoverBg: 'rgb(55 96 146 / 50%)',
  lightTableHeadBg: '#f9ce95',
  lightTableHeadHoverBg: 'rgb(249 206 149 / 50%)',
  // scroll-bar
  darkScrollbarThumbColor: '#999999',
  darkScrollbarTrackColor: '#555555',
  lightScrollbarThumbColor: '#cccccc',
  lightScrollbarTrackColor: '#ececec',
};
